export default {
  nav: {
    home: 'Home',
    manufacturers: 'Fabricants',
    products: 'Produits',
    about: 'À propos',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Contact',
    getQuote: 'Obtenir un devis',
  },
  langModal: {
    title: 'Nous sommes mondiaux',
    chooseLocation: 'Choisissez votre emplacement',
  },
  header: {
    email: "webenquiries{'@'}gmgautomation.net",
    phone: '+39 040 957 1062',
    language: 'Français',
    searchPlaceholder: 'Recherche par numéro de pièce ou fabricant',
    noResults: 'Aucune pièce trouvée',
    enquiryLink: 'Envoyer une demande',
    enquiryLinkSub: 'Vous ne trouvez pas votre pièce ? Contactez-nous',
  },
  quoteDrawer: {
    title: 'Envoyer une demande',
    parts: 'Numéro de pièce',
    addPart: 'Ajouter un autre article',
  },
  home: {
    hero: {
      title: 'Recherchez par numéro de pièce et trouvez des pièces d’automatisation, {highlight} et actuelles',
      highlight: 'obsolètes',
      subtitle:
        'Découvrez notre large gamme de produits pour tous vos besoins, comprenant des contrôleurs, des automates programmables, des interfaces homme-machine, des moteurs, des codeurs, des variateurs de servo, des onduleurs, des systèmes CNC et bien plus encore',
      searchPlaceholder: 'Entrez le numéro de pièce...',
      search: 'Rechercher',
    },
    manufacturers: {
      title: 'Fabricants',
      subtitle:
        "Notre vaste inventaire comprend des milliers de composants d'automatisation et de contrôle provenant de constructeurs OEM de premier plan, ce qui en fait une solution unique pour vos besoins. Si une pièce n'est pas en stock, soyez assuré que notre équipe multilingue effectuera des recherches dans le monde entier pour vous procurer le composant exact dont vous avez besoin au prix le plus compétitif.",
      viewProducts: 'Voir les produits',
      viewAll: 'Voir tous les fabricants',
    },
    whyUs: {
      title: 'Pourquoi choisir GMG Automatisation?',
      subtitle: "Les valeurs qui font de nous un partenaire de confiance pour l'automatisation industrielle",
      quality: {
        title: 'Service de Qualité',
        description: 'Service client amical et expérimenté pour fournir des solutions rapides et efficaces.',
      },
      shipping: {
        title: 'Expédition rapide',
        description:
          'Livraison le jour même sur les pièces en stock ou expédition express depuis notre réseau mondial.',
      },
      warranty: {
        title: '12 mois de garantie',
        description:
          "Nous offrons 12 mois de garantie sur toutes les pièces, qu'elles soient neuves, remises à neuf, réparées ou en échange de service.",
      },
    },
    services: {
      title: 'Prestations de service',
      subtitle: 'Solutions complètes pour tous vos besoins en pièces de rechange pour l’automatisation',
      learnMore: 'En savoir plus',
      supply: {
        title: 'Fournir',
        description:
          'Nous prenons soin de livrer votre pièce de notre stock ou de notre fournisseur directement à votre porte.',
      },
      exchange: {
        title: "Service d'échange",
        description:
          "Nous reprenons votre appareil défectueux en échange d'un appareil testé et fonctionnel à prix réduit.",
      },
      repair: {
        title: 'Réparation',
        description: "Nous pouvons réparer des milliers d'articles à des prix fixes.",
      },
    },
  },
  manufacturers: {
    searchPlaceholder: 'Rechercher des fabricants...',
    noResults: 'Aucun fabricant trouvé',
    hero: {
      title: 'Fabricants',
      subtitle: 'Découvrez notre large gamme de fabricants et la disponibilité de milliers de produits',
      badges: {
        warranty: { title: 'Garantie de 12 mois', subtitle: 'Sur toutes les pièces fournies' },
        response: { title: 'Réponse rapide', subtitle: 'Sous 24 heures' },
        delivery: { title: 'Livraison mondiale', subtitle: 'Expédition dans le monde entier' },
      },
    },
    products: {
      hero: {
        subtitle: 'Vous ne trouvez pas ce que vous recherchez ? Appelez-nous ou envoyez-nous une demande',
      },
      searchPlaceholder: 'Rechercher par numéro de pièce...',
      showingEntries: 'Affichage de {from} à {to} sur {total} pièces',
      noResults: 'Aucune pièce trouvée',
    },
  },
  about: {
    hero: {
      title: 'Trouver des solutions pour votre productivité est notre objectif ultime',
      subtitle:
        "Trouver des solutions de pièces de rechange d'automatisation pour minimiser les temps d'arrêt ou les longs délais de livraison des OEM",
    },
    values: {
      fast: {
        title: 'Rapide',
        desc: "Nous sommes connus pour notre réactivité et notre capacité à répondre rapidement à vos besoins, vous aidant ainsi à maintenir l'efficacité de vos systèmes d'automatisation.",
      },
      friendly: {
        title: 'Amical',
        desc: "Faites l'expérience d'un service client inégalé avec notre équipe amicale et dévouée, toujours prête à vous aider avec le sourire, rendant votre voyage avec nous fluide et satisfaisant.",
      },
      experienced: {
        title: 'Expérimenté',
        desc: "Forts de plusieurs années d'expérience dans l'industrie, nous proposons des conseils d'experts et des solutions de qualité, faisant de nous votre partenaire de confiance dans la fourniture de pièces de rechange pour l'automatisation.",
      },
      reliable: {
        title: 'Fiable',
        desc: "La fiabilité est au cœur de toutes nos opérations, tant dans la fourniture d'articles de qualité éprouvée que dans la gestion de l'organisation de vos commandes.",
      },
    },
    story1: {
      title: 'Notre équipe a réussi à comprendre les besoins de l’industrie',
      text: "GMG Automation a à cœur les préoccupations de ses clients cherchant des solutions à leurs pannes de machines ou à leurs besoins en pièces détachées obsolètes. C'est pourquoi nous avons développé un réseau mondial de fournisseurs pour fournir des solutions rentables et rapides.",
    },
    story2: {
      title: 'Création de services fiables pour les servir tous',
      text: "Avec plus de 10 ans d'expérience dans l'industrie de l'automatisation et une équipe multilingue à votre disposition, nous ne vous laissons pas dans l'embarras!",
    },
  },
  blog: {
    hero: {
      title: 'Blog',
      subtitle: 'Restez informé des dernières actualités et analyses de notre équipe',
    },
    empty: 'Aucun article trouvé.',
    back: 'Retour au blog',
    label: 'Article',
    related: 'Articles similaires',
  },
  faq: {
    hero: {
      title: 'FAQ',
      subtitle: 'Consultez nos questions fréquentes',
    },
    search: 'Rechercher dans les questions fréquentes',
    empty: 'Aucune question fréquente trouvée.',
  },
  contact: {
    hero: {
      title: 'Contactez-nous',
      subtitle:
        "Chez GMG Automation, nous sommes plus que de simples revendeurs de pièces détachées d'automatisation ; nous sommes vos partenaires engagés dans la réussite. Avec une équipe dédiée et multilingue à votre service, nous sommes prêts à vous aider pour toutes vos demandes",
    },
    offices: {
      title: 'Nos bureaux',
    },
    form: {
      title: 'Contactez-nous',
      name: 'Nom',
      company: "Nom de l'entreprise",
      email: 'Adresse e-mail',
      nameRequired: 'Le nom est obligatoire.',
      companyRequired: "Le nom de l'entreprise est obligatoire.",
      emailRequired: "L'e-mail est obligatoire.",
      phoneRequired: 'Le téléphone est obligatoire.',
      phone: 'Numéro de téléphone',
      phonePlaceholder: 'Ex. +33 1 23 45 67 89',
      message: 'Veuillez fournir les détails de votre demande',
      send: 'Envoyer',
      sending: 'Envoi en cours...',
      successTitle: 'Message envoyé',
      successDetail: 'Nous vous répondrons dès que possible.',
      errorTitle: 'Erreur',
      errorDetail: "Une erreur s'est produite. Veuillez réessayer.",
    },
    plantAddresses: {
      title: 'Adresse et coordonnées bancaires',
      regNumber: "Numéro d'enregistrement de l'entreprise",
      phone: 'Téléphone',
      bankDetails: 'Coordonnées bancaires',
      beneficiary: 'Bénéficiaire',
    },
  },
  terms: {
    hero: {
      title: 'Conditions Générales',
    },
    empty: 'Aucune condition générale trouvée.',
  },
  privacy: {
    hero: {
      title: 'Politique de Confidentialité',
    },
    empty: 'Aucune politique de confidentialité trouvée.',
  },
  cookie: {
    hero: { title: 'Politique de Cookies' },
    empty: 'Aucune politique de cookies trouvée.',
    banner: {
      message:
        "Nous utilisons des cookies pour améliorer votre expérience sur notre site. En continuant à naviguer, vous acceptez l'utilisation de cookies.",
      learnMore: 'Politique de Cookies',
      necessaryOnly: 'Nécessaires uniquement',
      acceptAll: 'Tout accepter',
    },
  },

  product: {
    manufacturer: 'Fabricants',
    partNumberLabel: 'Numéro de pièce',
    noDescription: 'Aucune description disponible',
    inStock: 'En stock',
    available: 'Disponible',
    qty: 'Quantité',
    addToCart: 'Ajouter au panier',
    addedToCart: 'Ajouté au panier',
    enquiryTitle: 'Demande Rapide',
    warrantyText: 'Tous les produits bénéficient d’une garantie de 12 mois.',
    fetchError: 'Impossible de charger le produit.',
    trust: {
      warranty: '12 mois de garantie sur tous les produits',
      shipping: 'Livraison rapide dans le monde entier',
      support: 'Service client professionnel',
    },
    features: {
      quality: 'Produit de qualité',
      delivery: 'Livraison rapide',
      warranty: 'Garantie de 12 mois',
    },
    tabs: {
      description: 'Description',
      warranty: 'Garantie',
    },
  },

  enquiryForm: {
    companyName: "Nom de l'entreprise",
    yourName: 'Nom',
    email: 'Email',
    country: 'Choisissez le pays',
    partNumber: 'Numéro de pièce',
    quantity: 'Quantité',
    send: 'Envoyer',
    phoneInput: {
      placeholder: 'Téléphone',
      searchPlaceholder: 'Recherche',
    },
    successTitle: 'Demande envoyée',
    successDetail: 'Nous vous répondrons dans les plus brefs délais.',
    errorTitle: 'Une erreur est survenue',
    errorDetail: 'Veuillez réessayer plus tard.',
  },

  searchEnquiry: {
    title: 'Résultats de recherche pour',
    whatNext: {
      title: 'Après l’envoi de votre demande',
      step1Title: '1. Email de Confirmation',
      step1Text: 'Vous recevrez un e-mail de confirmation indiquant que nous avons bien reçu votre demande.',
      step2Title: '2. Gestionnaire de Compte Dédié',
      step2Text:
        'Un membre de notre équipe vous contactera afin de confirmer les détails et les spécifications de votre demande.',
      step3Title: '3. Votre Devis',
      step3Text: 'Vous recevrez un devis complet, adapté à vos besoins spécifiques.',
      legal: 'Toutes les commandes sont soumises à la disponibilité des produits.',
      legalLink: 'Voir nos conditions générales.',
      askTeam: 'Demandez à notre équipe',
      emailLabel: 'Email',
    },
  },

  cart: {
    title: 'Panier de demandes',
    empty: 'Votre panier est vide',
    emptySub: 'Ajoutez des pièces depuis les pages produits pour commencer',
    browse: 'Parcourir les pièces',
    itemCount: '{count} pièce | {count} pièces',
    partNumber: 'Numéro de pièce',
    availability: 'Disponibilité',
    quantity: 'Quantité',
    clearAll: 'Tout effacer',
    clearTitle: 'Vider le panier',
    clearConfirm: 'Êtes-vous sûr de vouloir supprimer tous les articles du panier ?',
    clear: 'Vider',
    cancel: 'Annuler',
    enquirySubtitle: '{count} pièce dans votre demande | {count} pièces dans votre demande',
    addedTitle: 'Ajouté au panier',
    addedDetail: '{partNumber} a été ajouté à votre panier de demande',
  },

  footer: {
    contact: {
      title: 'Autres moyens pour nous Contacter',
      subtitle: 'Contactez-nous par téléphone ou en envoyant un formulaire en ligne, nous serons ravis de vous aider!',
      formTitle: 'Envoyer un formulaire en ligne',
      formSubtitle: 'Partagez vos besoins et nous répondrons dans les 24 heures.',
      enquiry: 'Envoyer une demande',
      callTitle: 'Appelez-nous',
      callSubtitle: 'Parlez directement avec notre équipe multilingue.',
    },
    sections: {
      manufacturers: 'Fabricants',
      quickLinks: 'Liens rapides',
      connect: 'Contact',
    },
    actions: {
      whatsapp: 'WhatsApp',
    },
    legal: {
      rights: 'Tous droits réservés',
      privacy: 'Politique de confidentialité',
      terms: 'Conditions générales d’utilisation',
    },
    recaptcha: 'Protégé par reCAPTCHA',
    recaptchaPrivacy: 'Confidentialité',
    recaptchaTerms: 'Conditions d’utilisation',
    disclaimer:
      'GMG Automation n’est ni un distributeur ni un représentant autorisé des marques présentes sur ce site. Les marques déposées et les noms mentionnés sur ce site appartiennent à leurs propriétaires respectifs.',
  },

  common: {
    noResults: 'Aucun résultat',
  },

  validation: {
    required: 'Ce champ est obligatoire',
    emailInvalid: 'Veuillez saisir une adresse e-mail valide',
    tooLong: 'Ne doit pas dépasser {max} caractères',
    recaptchaError: 'La vérification reCAPTCHA a échoué. Veuillez réessayer.',
  },

  seo: {
    home: {
      title: 'GMG Automation — Pièces Détachées pour Automatisation Industrielle',
      description: 'Trouvez des pièces d\'automatisation industrielle obsolètes et actuelles. Recherchez par numéro de pièce et demandez un devis sous 24 heures. Automates, IHM, servodrives et plus encore.',
    },
    manufacturers: {
      title: 'Fabricants — GMG Automation',
      description: 'Parcourez les pièces d\'automatisation par fabricant. Siemens, ABB, Schneider Electric, Fanuc et des centaines d\'autres. Livraison rapide dans le monde entier avec garantie 12 mois.',
    },
    about: {
      title: 'À Propos — GMG Automation',
      description: 'Plus de 10 ans d\'expérience dans les pièces détachées pour l\'automatisation industrielle. Équipe multilingue, réseau mondial de fournisseurs, réponse rapide et garantie 12 mois.',
    },
    blog: {
      title: 'Blog — GMG Automation',
      description: 'Restez informé des dernières actualités, analyses sectorielles et articles techniques de l\'équipe GMG Automation.',
    },
    faq: {
      title: 'FAQ — GMG Automation',
      description: 'Réponses aux questions fréquentes sur les commandes, la livraison, le paiement et la garantie chez GMG Automation.',
    },
    contact: {
      title: 'Contactez-nous — GMG Automation',
      description: 'Contactez l\'équipe GMG Automation. Appelez-nous, envoyez un formulaire ou écrivez-nous directement. Nous répondons sous 24 heures.',
    },
    terms: {
      title: 'Conditions Générales — GMG Automation',
      description: 'Lisez les conditions générales régissant l\'utilisation des services GMG Automation et l\'achat de pièces détachées industrielles.',
    },
    privacy: {
      title: 'Politique de Confidentialité — GMG Automation',
      description: 'Découvrez comment GMG Automation collecte, utilise et protège vos données personnelles conformément aux réglementations en vigueur.',
    },
    cookie: {
      title: 'Politique de Cookies — GMG Automation',
      description: 'Découvrez les cookies utilisés sur le site GMG Automation et comment gérer vos préférences.',
    },
    product: {
      description: 'Achetez {partNumber} de {manufacturer}. Demandez un devis pour une livraison rapide dans le monde entier. Garantie 12 mois incluse.',
    },
    manufacturerProducts: {
      description: 'Parcourez les pièces détachées et composants d\'automatisation {manufacturer}. Recherchez par numéro de pièce et demandez un devis avec livraison rapide.',
    },
  },
}
